import { render, staticRenderFns } from "./odd-pagination.vue?vue&type=template&id=3313c32d&lang=pug&"
import script from "./odd-pagination.vue?vue&type=script&lang=js&"
export * from "./odd-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports